import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import MetricsBar from './components/MetricsBar';
import Features from './components/Features';
import Showcase from './components/Showcase';
import Examples from './components/Examples';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans selection:bg-gray-200 selection:text-gray-900">
      <Header />
      <main>
        <Hero />
        <MetricsBar />
        <Features />
        <Showcase />
        {/* Moduł "Przykłady" dodany tuż nad Cennikiem */}
        <Examples />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;